<div class="container">
    <div class="row main">
        <div class="main-login main-center col-xs-12 col-md-10 col-lg-8">
            <div *ngIf="loginService.connectivityError" class="alert alert-danger login-failed">
                <strong> {{ modelService.getString('login_network_error')}} </strong><br>
                {{extraInfoString}}
            </div>
            <div *ngIf="loginService.loginError === true" class="alert alert-danger login-failed">
                <strong> {{ modelService.getString('login_failed')}} </strong>
            </div>
            <!--div *ngIf="loginService.emailExists === true" class="alert alert-danger login-failed">
                <strong> {{ modelService.getString('email_exists')}} </strong>
            </div-->
            <div *ngIf="loginService.notActiveError" class="alert alert-danger login-failed">
                <strong> {{ modelService.getString('login_not_activated')}} </strong>
            </div>
            <div *ngIf="loginService.accountCreated" class="alert alert-success register-ok">
                <strong> {{ modelService.getString('login_created')}} </strong>
            </div>
            <div *ngIf="loginService.passwordRecover" class="alert alert-success recover-ok">
                <strong> {{ modelService.getString('login_password_sent')}} </strong>
            </div>
            <form class="form-horizontal" #loginForm="ngForm">
                <div class="form-group">
                    <label for="email" class="cols-sm-2 control-label"> {{ modelService.getString('email') }} </label>
                    <div class="input-group">
                        <span class="input-group-text"><i class="fa fa-envelope fa" aria-hidden="true"></i></span>
                        <input #fieldUsername autofocus required name="username" id="username" type="email" class="form-control" [disabled]="loading" [(ngModel)]="username" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" placeholder="{{ modelService.getString('email_input')}}"
                        />
                    </div>
                </div>
                <div class="form-group">
                    <label for="password" class="cols-sm-2 control-label">{{ modelService.getString('password')}}</label>
                    <div class="input-group">
                        <span class="input-group-text"><i class="fa fa-lock fa-lg" aria-hidden="true"></i></span>
                        <input #fieldPassword required name="password" id="password" type="password" class="form-control" [disabled]="loading" [(ngModel)]="password" (keyup.enter)="login()" placeholder="{{ modelService.getString('password_input') }}" />
                    </div>
                </div>
                <div class="form-group">
                    <label for="rememberMe" class="cols-sm-2 checkbox-inline"><span>{{ modelService.getString('remember_me')}}</span>
						<input #fieldRememberMe type="checkbox" [class.disabled]="loading" name="rememberMe"
							id="rememberMe" [ngModel]="rememberMe" (ngModelChange)="shouldRemember($event)" />
					</label>
                </div>

                <div class="form-group ">
					<button type="button"
						(click)="login()"
						[disabled]="!loginForm.form.valid || loading"
						class="btn btn-primary btn-lg btn-block login-button">
						<span *ngIf="!loading">{{ modelService.getString('login') }}</span>
						<i *ngIf="loading" class="fa fa-spinner spin"></i>
					</button>
                </div>
                <div class="login-register">
                    <a routerLink="/legaltext">{{ modelService.getString('new_user') }}</a>
                </div>
                <div class="login-recover">
                    <a routerLink="/recover">{{ modelService.getString('forgot_password') }}</a>
                </div>
            </form>
        </div>
        <div class="main-center col-xs-12 col-md-10 col-lg-8">
            <p class="warningRivisa">
				<span class="login-warning-rivisaA">{{modelService.getString('login_warning_rivisaA')}}</span>
				<span class="login-warning-rivisaB">&nbsp;{{modelService.getString('login_warning_rivisaB')}}</span>
				<span class="login-warning-rivisaC">&nbsp;{{modelService.getString('login_warning_rivisaC')}}</span>
			</p>
        </div>
    </div>
</div>